import React from "react";
import Page from "../../components/Page";

import CompanyForm from "../../components/forms/CompanyForm";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import { FormMode } from "../../types/enums";

const CreateCompanyPage = () => (
  <Page enableGoBack title="Bedrijf toevoegen">
    <CenteredPageContentContainer>
      <PaperContainer title="Bedrijf toevoegen">
        <CompanyForm mode={FormMode.CREATE} />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default CreateCompanyPage;



// WEBPACK FOOTER //
// ./src/pages/Company/CreateCompanyPage.js